import {
  background,
  breakpoint,
  body,
  border,
  borderRadius,
  heading,
  spacing,
  text
} from '@carvana/ds-styles';
import LinkButton from '@carvana/ds-link-button';
import styled from 'styled-components';
import Banner from '@carvana/ds-banner';

export const HeroRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media screen and (min-width: ${breakpoint.lg}) {
    flex: 1;
  }
`;

export const TilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const TileCard = styled.div<{ $size?: 'sm' | 'md' | 'lg' }>`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: ${props => (props.$size === 'md' ? 'column' : 'row')};
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: ${props => {
    if (props.$size === 'sm') return `${spacing.xl} ${spacing['2Xl']}`;
    if (props.$size === 'md') return spacing['2Xl'];
    return spacing['3Xl']; // 'lg' or default
  }};
  border: 1px solid ${border.weak};
  border-radius: ${borderRadius.md};
  background-color: ${background.default};
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s ease;
  row-gap: ${props => (props.$size === 'md' ? spacing.lg : '0')};
  column-gap: ${spacing.lg};
  margin-bottom: ${spacing.xl};
  max-width: 551px;

  &:hover {
    border-color: ${border.strong};
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    border-radius: ${borderRadius.xl};
    max-width: 582px;
  }
  @media screen and (min-width: ${breakpoint.md}) {
    border-radius: ${borderRadius.xl};
    max-width: 624px;
  }
`;

export const ImageWrapper = styled.div<{
  $hasImage: boolean;
  $size?: 'sm' | 'md' | 'lg';
  $overrideImageBackground?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => {
    if (!props.$hasImage) return '0';
    if (props.$size === 'sm') return '48px';
    if (props.$size === 'lg') return '131px';
    return '90px'; // default to 'md'
  }};
  height: ${props => {
    if (!props.$hasImage) return '0';
    if (props.$size === 'sm') return '38px';
    if (props.$size === 'md') return '72px';
    if (props.$size === 'lg') return '105px';
    return 'auto';
  }};
  margin-right: ${props => (props.$hasImage ? spacing.xl : '0')};
  background-color: ${({ $overrideImageBackground }) =>
    $overrideImageBackground ? 'none' : background.weak};
  border-radius: ${borderRadius.md};
  transition: width 0.3s ease, margin-right 0.3s ease;

  @media screen and (min-width: ${breakpoint.sm}) {
    border-radius: ${borderRadius.lg};
  }
`;

export const ContentWrapper = styled.div<{ $size?: 'sm' | 'md' | 'lg' }>`
  display: flex;
  flex-direction: row;
  align-self: flex-start;
  align-items: center;
  width: ${props => (props.$size === 'md' ? '100%' : '66%')};
`;

export const VehicleInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};
`;

export const PriceExpirationWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${spacing.sm};
`;

export const VehicleValue = styled.span<{ $mobileSize?: boolean }>`
  ${({ $mobileSize }) => ($mobileSize ? heading.lg : heading['2Xl'])}
  color: ${text.strong};
`;

export const VehicleTrim = styled.span`
  ${body.regular.sm};
  color: ${text.default};
`;

export const YearMakeModel = styled.div`
  ${body.strong.sm};
  color: ${text.strong};
`;

export const StyledLinkButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
`;

export const TileActionModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.lg};
  margin-bottom: ${spacing['2Xl']};
  text-align: center;
`;

export const TileActionModalTitle = styled.div`
  ${heading.md};
  color: ${text.strong};
  text-align: center;
`;

export const TileActionModalBody = styled.div`
  ${body.regular.sm};
  color: ${text.default};
  text-align: center;
`;

export const TileActionModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  width: 100%;
`;

export const TileActionsButton = styled.button`
  position: absolute;
  top: ${spacing.md};
  right: ${spacing.md};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: none;
  border: none;
  border-radius: ${borderRadius.sm};
  cursor: pointer;
  color: ${text.default};

  &:hover {
    background-color: ${background.weak};
  }
`;

export const StyledBanner = styled(Banner)`
  padding-top: ${spacing.sm};
  padding-bottom: ${spacing.sm};
  margin-bottom: ${spacing.xl};
`;
